import { render, staticRenderFns } from "./VariableTranslations.vue?vue&type=template&id=dcf3a088&"
import script from "./VariableTranslations.vue?vue&type=script&lang=js&"
export * from "./VariableTranslations.vue?vue&type=script&lang=js&"
import style0 from "./VariableTranslations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports